import { useEffect, useState } from 'react';
import { Grid, useTheme } from '@mui/material';
import AccountCircleTwoTone from '@mui/icons-material/AccountCircleTwoTone';
import SideIconCard from './components/SideIconCard';

import SummaryCard from './components/SummaryCard';

const MultiCatalog = ({ merchant }: any) => {
    const [firstLev, setFirstLevel] = useState<any>();
    const theme = useTheme();

    useEffect(() => {
        setFirstLevel(merchant);
    }, [merchant]);

    return (
        <>
            {firstLev && (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <SideIconCard
                            iconPrimary={AccountCircleTwoTone}
                            primary="2,672"
                            secondary="Last week"
                            color={
                                // eslint-disable-next-line no-nested-ternary
                                firstLev?.overallScore <= 34
                                    ? theme.palette.error.main
                                    : firstLev.overallScore > 34 && firstLev.overallScore <= 80
                                    ? theme.palette.warning.main
                                    : theme.palette.success.main
                            }
                            metrics={firstLev}
                            name={firstLev?.name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SummaryCard data={firstLev} />
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default MultiCatalog;
